// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fixed height so the board NEVER moves when a word appears/clears. */
.wordInProgressContainer {
  position: relative;
  flex: 0 0 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.currentWord {
  font-family: var(--font-board);
  font-weight: 600;
  font-size: 2rem;
  letter-spacing: 0.06em;
  line-height: 1;
  color: var(--palette-text);
  /* Underline space is always reserved (transparent when empty) so the
     element's box size never changes between empty and filled. */
  border-bottom: 3px solid transparent;
  padding-bottom: 6px;
}
.currentWord:not(:empty) {
  border-bottom-color: var(--palette-primary);
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/wordInProgress.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,0BAA0B;EAC1B;iEAC+D;EAC/D,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C","sourcesContent":["/* Fixed height so the board NEVER moves when a word appears/clears. */\n.wordInProgressContainer {\n  position: relative;\n  flex: 0 0 64px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.currentWord {\n  font-family: var(--font-board);\n  font-weight: 600;\n  font-size: 2rem;\n  letter-spacing: 0.06em;\n  line-height: 1;\n  color: var(--palette-text);\n  /* Underline space is always reserved (transparent when empty) so the\n     element's box size never changes between empty and filled. */\n  border-bottom: 3px solid transparent;\n  padding-bottom: 6px;\n}\n.currentWord:not(:empty) {\n  border-bottom-color: var(--palette-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
